<template lang='pug'>
  div
    | Webhook HTTP Headers
    bionic-metrics-monaco-simple-editor.inline-editor(
      ref='editor'
      type='webhook'
      git-name='webhook.json'
      v-model='webhookHeaders'
      mode='json')
    | These HTTP Headers will be attached to HTTP Posts triggered from Webhook Notifications that can be configured for a Suite in the Notifications Section.
    | Example:
    pre.code {"Authorization": "Bearer [token]", "Header-Title": "Header-Content"}
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {createHelpers} from 'vuex-map-fields';
import Notifications from '../services/notification.service';
import SaveMixin from '../mixins/save.mixin';
import BionicMetricsMonacoSimpleEditor from './MonacoSimpleEditor';

// We're using the same getter and mutation types
// as we've used in the store above.
const {mapFields} = createHelpers({
  getterType: 'getAccountField',
  mutationType: 'updateAccountField'
});

export default {
  name: 'WebhookConfig',
  components: {BionicMetricsMonacoSimpleEditor},
  mixins: [SaveMixin],
  computed: {
    ...mapGetters({
      dirty: 'isAccountDirty',
      user: 'getUser',
      account: 'getAccount'
    }),
    ...mapFields({
      webhookHeaders: 'account.webhookHeaders'
    })
  },
  methods: {
    async save() {
      try {
        await this.updateAccount();
        await this.refreshUser(); // so our stored user/account reflects reality
      } catch (e) {
        Notifications.errorToast('Error Saving Check Console For Details', {
          duration: 100000,
          retry: this.save
        });
        console.error(e);
      }
      console.log('save');
    },
    ...mapActions({
      refreshUser: 'refreshUser',
      updateAccount: 'updateAccount',
      getAccount: 'getAccount'
    }),
    ...mapMutations({clearDirty: 'clearAccountDirty'})
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
  .inline-editor {
    width: 100%;
    min-height: 20vh;
  }
</style>
